import { Dropdown } from "primereact/dropdown";
import React from "react";

import { EquipmentAttributeDefinition } from "domain/entities/equipment-attribute-definition";
import InputTextComponent from "presentation/components/Shared/InputTextComponent";
import Spinner from "presentation/components/Shared/Spinner";

interface EquipmentAttributesTabProps {
  loading: boolean;
  visibleAttrDefs: EquipmentAttributeDefinition[];
  attributesObject: Record<string, any>;
  setAttributesObject: (attrs: Record<string, any>) => void;
  isAdminOrPatrimonio: boolean;
  tabContentStyle: React.CSSProperties;
  dropdownLabelStyle: React.CSSProperties;
}

const EquipmentAttributesTab: React.FC<EquipmentAttributesTabProps> = ({
  loading,
  visibleAttrDefs,
  attributesObject,
  setAttributesObject,
  isAdminOrPatrimonio,
  tabContentStyle,
  dropdownLabelStyle,
}) => {
  const renderAttributeInput = (
    definition: EquipmentAttributeDefinition,
    isEditable: boolean,
  ) => {
    const typeUpper = (definition.type || "").toUpperCase();

    if (typeUpper === "SELECT") {
      const options = (definition.options || "")
        .split(",")
        .map((option) => option.trim())
        .filter(Boolean);

      return (
        <span className="p-float-label w-full">
          <Dropdown
            id={definition.name}
            options={options.map((option) => ({
              label: option,
              value: option,
            }))}
            value={attributesObject?.[definition.name] ?? ""}
            onChange={(e) =>
              setAttributesObject({
                ...attributesObject,
                [definition.name]: e.value,
              })
            }
            className="w-full"
            showClear
            disabled={!isEditable}
          />
          <label htmlFor={definition.name} style={dropdownLabelStyle}>
            {definition.name}
          </label>
        </span>
      );
    }

    if (typeUpper === "BOOLEAN") {
      return (
        <span className="p-float-label w-full">
          <Dropdown
            id={definition.name}
            options={[
              { label: "Sim", value: true },
              { label: "Não", value: false },
            ]}
            value={attributesObject?.[definition.name] ?? ""}
            onChange={(e) =>
              setAttributesObject({
                ...attributesObject,
                [definition.name]: e.value,
              })
            }
            className="w-full"
            showClear
            disabled={!isEditable}
          />
          <label htmlFor={definition.name} style={dropdownLabelStyle}>
            {definition.name}
          </label>
        </span>
      );
    }

    return (
      <InputTextComponent
        fieldName={definition.name}
        label={definition.name}
        currentObject={attributesObject}
        getValue={attributesObject[definition.name]}
        setValue={setAttributesObject}
        isDisable={!isEditable}
      />
    );
  };

  return (
    <div style={tabContentStyle}>
      {loading ? (
        <Spinner />
      ) : (
        <div className="formgrid grid mt-3">
          {visibleAttrDefs.map((definition) => {
            const isEditable = isAdminOrPatrimonio || definition.isUserEditable;

            return (
              <div
                key={definition.id}
                className="field col-12 md:col-6 mb-5 mt-2"
              >
                {renderAttributeInput(definition, isEditable)}
              </div>
            );
          })}
          {visibleAttrDefs.length === 0 && (
            <div className="col-12 text-center text-gray-500 py-4">
              Nenhuma característica adicional configurada para este tipo de
              equipamento.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EquipmentAttributesTab;
